// openBetSlice.js

import {
    createSlice,
    createAsyncThunk,
} from "@reduxjs/toolkit";

import {
    getOpenBets,
} from "../../../services/users";

/*
 * Open bets API thunk
 */
export const getAllBets =
    createAsyncThunk(
        "reports/allOpenBets",

        async (
            params,
            { rejectWithValue }
        ) => {
            try {
                const response =
                    await getOpenBets(params);

                return response.data;
            } catch (error) {
                const errorData =
                    error.response?.data || {
                        result: 0,
                        resultData: [],
                        resultMessage:
                            error.message ||
                            "User bets fetch failed",
                    };

                return rejectWithValue(
                    errorData
                );
            }
        }
    );

const openBetSlice = createSlice({
    name: "bets",

    initialState: {
        bets: [],
        loading: false,
        error: null,
    },

    reducers: {
        setOpenBets(state, action) {
            state.bets = Array.isArray(
                action.payload
            )
                ? action.payload
                : [];
        },

        clearOpenBets(state) {
            state.bets = [];
            state.loading = false;
            state.error = null;
        },
    },

    extraReducers: (builder) => {
        builder
            /*
             * Polling request start hone par existing bets
             * clear nahi karni. Otherwise table har 2
             * seconds me blink/flicker karegi.
             */
            .addCase(
                getAllBets.pending,
                (state) => {
                    state.loading = true;
                    state.error = null;
                }
            )

            /*
             * Successful API response:
             * Empty resultData par bets [] ho jayengi,
             * jisse admin-deleted bet UI se remove hogi.
             */
            .addCase(
                getAllBets.fulfilled,
                (state, action) => {
                    state.loading = false;
                    state.error = null;

                    const resultData =
                        action.payload?.resultData;

                    console.log(
                        "OPEN BET API RESULT DATA:",
                        resultData
                    );

                    console.log(
                        "OPEN BET API IDS:",
                        Array.isArray(resultData)
                            ? resultData.map(
                                (bet) =>
                                    bet._id ||
                                    bet.betting_id
                            )
                            : []
                    );


                    state.bets =
                        Array.isArray(resultData)
                            ? resultData
                            : [];
                }
            )

            /*
             * Temporary API failure par existing bets ko
             * retain karo. Network failure ko deletion
             * samajh kar table empty nahi karni.
             */
            .addCase(
                getAllBets.rejected,
                (state, action) => {
                    state.loading = false;

                    state.error =
                        action.payload
                            ?.resultMessage ||
                        action.payload?.message ||
                        "User bets fetch failed";
                }
            );
    },
});

export const {
    setOpenBets,
    clearOpenBets,
} = openBetSlice.actions;

export default openBetSlice.reducer;